export class CustomConsensusInfo {
  company: string;
  cut: string;
  source: string;
  jsonData: JSONData;
}

export class JSONData {
  Custom: JSONDataCustom;
}

export class JSONDataCustom {
  selected_cc: Array<string>;
  excl_non_entitled_brokers: boolean;
  non_entitled_brokers: boolean;
  date_custom_consensus: string;
  custom_consensus_date_type: string;
  custom_consensus_broker_type: string;
  inc_non_current_brokers: number;
  relative_days: number;
}

// export class DateBasedCustomConsensusInfo {
//   excludeNonEntitledBrokers: Array<string>;
//   nonEntitledBrokers: Array<string>;
// }

// export class Broker {
//   @Expose({ name: "modeldate" })
//   modeldate: string;
//   @Expose({ name: "daydiff" })
//   dayDiff: string;
//   @Expose({ name: "analystemail" })
//   analystEmail: string;
//   @Expose({ name: "analystname" })
//   analystName: string;
//   @Expose({ name: "selected_cc" })
//   isSelected: boolean;
//   @Expose({ name: "entitled" })
//   entitled: boolean;
//   @Expose({ name: "name" })
//   name: string;
//   @Expose({ name: "excluded" })
//   isExcluded: boolean;
//   @Expose({ name: "sourceid" })
//   sourceId: number;
//   @Expose({ name: "modeldatetime" })
//   modeldatetime: number;
// }

// export class CCInfo {
//   @Expose({ name: "excl_non_entitled_brokers" })
//   excludedNonEntiledBrokers: string;
//   @Expose({ name: "selected_excl_cc_not_entitled" })
//   isExcludedCCSelected: boolean;
//   @Expose({ name: "non_entitled_brokers" })
//   notEntitledBrokers: string;
//   @Expose({ name: "selected_cc_not_entitled" })
//   isNotEntitledCCSelected: boolean;
//   @Expose({ name: "date_custom_consensus" })
//   ccDate: string;
//   @Expose({ name: "sort_order" })
//   sortOrder: string;
//   @Expose({ name: "sort_column" })
//   sortColumn: string;
//   @Expose({ name: "show_only_current_cc" })
//   showOnlyCurrentCC: boolean;
//   @Expose({ name: "inc_non_current_brokers" })
//   includeNonCurrentBrokers: boolean;
//   @Expose({ name: "values" })
//   @Transform(({ value }) => {
//     console.log(value);
//     const brokers = value.filter((val) => {
//       return val.name.toLowerCase() === "brokers";
//     });
//     return brokers[0].values;
//   })
//   brokers?: BrokerItem[] | null;
//   @Exclude()
//   selectedBrokers: number[] | null;
// }

// export class TimeBasedCCInfo {
//   @Expose({ name: "custom_sourceid_list" })
//   sourceIds: number[];
// }
